import { Navigate } from 'react-router-dom';

const DEMO_EVENT_ID = 'f83c2769-b4aa-4ba9-9e3e-5e205fd40047';

const DemoEventManagementRedirect = () => {
  return <Navigate to={`/demo/event-management/${DEMO_EVENT_ID}`} replace />;
};

export default DemoEventManagementRedirect;
